import styled from "styled-components";

export const Overlay = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 80px;
  box-sizing: border-box;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1200;
`;

export const Popup = styled.div`
  width: 420px;
  max-height: calc(100vh - 160px);
  padding: 24px;
  box-sizing: border-box;
  border-radius: 14px;
  background: #fff;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  > .title {
    color: #121212;
    font-family: Pretendard;
    font-size: 20px;
    font-weight: 700;
  }

  > img {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
`;

export const TicketList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  max-height: 420px;
`;

export const TicketItem = styled.div<{ $selected?: boolean; $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  border-radius: 10px;
  background: ${({ $selected }) => ($selected ? "#e8d9ff" : "#ecf0f3")};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

  > .name {
    color: #121212;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 700;
  }

  > .info {
    display: flex;
    justify-content: space-between;
    color: #666;
    font-family: Pretendard;
    font-size: 12px;
    font-weight: 500;
  }
`;

export const EmptyMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 160px;
  color: #969696;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
`;

export const ClearButton = styled.div`
  margin-top: 12px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  color: #666;
  font-family: Pretendard;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
`;
